export default function cookieFetch() {
  var _ck = {}
  document.cookie.split("; ").map((e) => {
    var kv = e.split("=")
    _ck[kv[0]] = kv[1]
  })
  return _ck
}